import { computed, effect, Injectable } from '@angular/core';
import { ProjectSignalrService } from '@web-portal/domains/project/data-access';
import { ProjectStore } from '@web-portal/domains/shared/domain-models';

@Injectable()
export class ProjectFacade {
  private readonly projectStore = new ProjectStore();
  private readonly _projectSignalrService = new ProjectSignalrService();

  public readonly projects = this.projectStore.projects;
  public readonly selectedProject = this.projectStore.selectedProject;
  public readonly projectIfcFilesToUpload = this.projectStore.projectIfcFilesToUpload;
  public readonly projectSignalrService = this._projectSignalrService;

  public readonly projectName = this.projectStore.projectName;
  public readonly isProjectAdmin = computed(() => {
    const rights = this.selectedProject()?.rights as Record<string, boolean> | undefined;
    return rights?.['projectAdmin'] === true;
  });
  public readonly isProjectEditor = computed(() => {
    const rights = this.selectedProject()?.rights as Record<string, boolean> | undefined;
    return rights?.['projectEdit'] === true;
  });
  public readonly isProjectViewer = computed(() => {
    return !this.isProjectEditor() && !this.isProjectAdmin();
  });

  constructor() {
    this.projectSignalrService.init();
    let lastProjectId: string | undefined = undefined;

    effect(() => {
      const project = this.selectedProject();

      if (project?.id !== lastProjectId) {
        lastProjectId = project?.id;
        this.projectSignalrService.setSelectedProject(project);
      }
    });
  }
}
